import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { DatePickerField } from "./DatePicker";
import { PAYMENT_METHODS } from "../lib/constants";

export const todayLocal = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const MethodPicker = ({ value, onChange, testId }) => (
  <div className="grid grid-cols-2 gap-1.5" data-testid={testId}>
    {PAYMENT_METHODS.map((m) => (
      <button key={m.key} type="button" data-testid={`${testId}-${m.key}`} onClick={() => onChange(m.key)}
        className={`text-xs px-2 py-1.5 rounded-md border transition-colors ${value === m.key ? "bg-ccc-navy text-white border-ccc-navy" : "border-slate-200 text-slate-600 hover:border-ccc-blue"}`}>
        {m.label}
      </button>
    ))}
  </div>
);

export const MarkPaidPopover = ({ onConfirm, testId, children }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(todayLocal());
  const [method, setMethod] = useState("upi");
  const invalid = !date || date > todayLocal() || !method;
  const confirm = async () => {
    if (invalid) return;
    await onConfirm(date, method);
    setOpen(false);
  };
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o) { setDate(todayLocal()); setMethod("upi"); } }}>
      <PopoverTrigger asChild onClick={(e) => e.stopPropagation()}>{children}</PopoverTrigger>
      <PopoverContent className="w-64 space-y-3" onClick={(e) => e.stopPropagation()} data-testid={`${testId}-popover`}>
        <div>
          <Label className="text-xs">Payment date</Label>
          <div className="mt-1"><DatePickerField value={date} onChange={setDate} testId={`${testId}-date`} /></div>
        </div>
        <div>
          <Label className="text-xs">Paid via</Label>
          <div className="mt-1"><MethodPicker value={method} onChange={setMethod} testId={`${testId}-method`} /></div>
        </div>
        <Button size="sm" disabled={invalid} onClick={confirm} className="w-full bg-ccc-emerald hover:bg-emerald-600 text-white" data-testid={`${testId}-confirm`}>Confirm paid</Button>
      </PopoverContent>
    </Popover>
  );
};
